import React from 'react';
import { NavLink } from 'react-router';
import { Row } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import {
  dateFormatter, infoFormatterIntl,
} from '../../../../utils/formatters';
import { PROCEDURE_TYPE } from '../../../../configs';
import FileView from '../../../../components/fields/FileInput/FileView';

export default function ApplicationCarrierSzltView({ data = {}, currentApplication = {}, fieldsValidation }) {
  const {
    order_services_attach = [],
  } = data;
  const hasOrderServices = order_services_attach && order_services_attach.length > 0;
  const {
    procedure: currentProcedure,
    files = [],
  } = currentApplication;

  const order_service_contract_files = files && files.length ? files.find(item => item.collection_name === 'order_service_contract_files') : undefined;

  return (
    <>
      {
        currentProcedure === PROCEDURE_TYPE.PROCEDURE_1227_1 || currentProcedure === PROCEDURE_TYPE.PROCEDURE_1227_5 ? (
          <>
            <div className="f4 mt-3">{currentProcedure === PROCEDURE_TYPE.PROCEDURE_1227_1 ? 'Номер в реестре СЗЛТ' : 'Добавить СЗЛТ'} </div>
            {((hasOrderServices && order_services_attach) || []).map((attach, index) => (
              <div key={`order-service-attach${index}`}>
                <Row className="row-cols-3">
                  {infoFormatterIntl('order_service_numbers', <NavLink target="_blank" to={`/region-registry/szlt?numbers=${attach?.order_service_number}`}>{attach?.order_service_number}</NavLink>, fieldsValidation, `application_carrier.order_services_attach.${index}.order_service_number`)}
                  {infoFormatterIntl('order_service_contract_number', attach?.contract_number, fieldsValidation, `application_carrier.order_services_attach.${index}.contract_number`)}
                  {infoFormatterIntl('order_service_contract_effective_date', dateFormatter(attach?.contract_effective_date), fieldsValidation, `application_carrier.order_services_attach.${index}.contract_effective_date`)}
                </Row>
                <Row className="row-cols-3">
                  {infoFormatterIntl('order_service_contract_expiration_date', dateFormatter(attach?.contract_expiration_date), fieldsValidation, `application_carrier.order_services_attach.${index}.contract_expiration_date`)}
                  {infoFormatterIntl('media.order_service_contract_files', order_service_contract_files ? <FileView readOnly withoutMime withoutHr files={[order_service_contract_files]} /> : null, fieldsValidation, 'order_service_contract_files', 4)}
                </Row>
              </div>
            ))}
          </>
        ) : null
      }
      <div className="mb-3" />
    </>
  );
}
